import QuoteDetails from "../../../model/quote/QuoteDetails";

/**
 * Fetch quote details successful action.
 */
export const QUOTE_DETAILS_FETCHED = "QUOTE_DETAILS_FETCHED";
export type QUOTE_DETAILS_FETCHED = { quoteDetails: QuoteDetails };

/**
 * Update quote finance product successful action.
 */
export const QUOTE_FINANCE_PRODUCT_UPDATED = "QUOTE_FINANCE_PRODUCT_UPDATED";
export type QUOTE_FINANCE_PRODUCT_UPDATED = { quoteId: string, financeProductId: string };
